import React from 'react';
import { Form, Button, Row, Col, DatePicker, Input, Select } from 'antd';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';
const { Option } = Select;

const FormFilter = ({ form: { getFieldDecorator, validateFields, resetFields }, onSearch, roles, categories, isMember, loadingCategory }) => {
  const itemLayout = {
    md: 8,
    sm: 12,
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    },
  };
  const handleSearch = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        onSearch(values);
      }
    });
  };
  const handleReset = (e) => {
    e.preventDefault();
    resetFields();
    onSearch();
  };

  return (
    <Form onSubmit={handleSearch}>
      <Row gutter={32}>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Time">
            {getFieldDecorator('created_at', {
              initialValue: [],
            })(<RangePicker
              format={dateFormat}
            />)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="CRM ID">
            {getFieldDecorator('project', {
              initialValue: '',
            })(<Input />)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Category">
            {getFieldDecorator('category', {
              initialValue: [],
            })(<Select loading={loadingCategory} optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
            }  placeholder='Chọn Category'>
              {categories.map((category, key) => <Option key={`category_${key}`} value={category.name}>{category.name}</Option>)}
          </Select>)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Total Price">
            {getFieldDecorator('price', {
              initialValue: '',
            })(<Input />)}
          </Form.Item>
        </Col>
        {!isMember && <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Member">
            {getFieldDecorator('created_by', {
              initialValue: [],
            })(<Select allowClear placeholder='Chọn email' style={{ width: '100%' }} optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
              {roles.map(role => <Option key={role.email} value={role.email}>{role.email}</Option>)}
            </Select>)}
          </Form.Item>
        </Col>}
      </Row>
      <Row className='filter-segment'>
        <Col span={24}>
          <Button onClick={handleSearch} icon='search' type='primary'>Tìm kiếm</Button>
          {' '}
          <Button onClick={handleReset} icon='reload'>Reset</Button>
        </Col>
      </Row>
    </Form>
  );
};
export default Form.create({ name: 'form_filter_crisis' })(FormFilter);
